const scheduler = {
  err_invalid_timezone: {
    message: 'Attempting to create an interview with an invalid timezone',
  },
  err_start_time_missing: {
    message: 'Attempting to create an interview without a start time',
  },
  err_end_time_missing: {
    message: 'Attempting to create an interview without an end time',
  },
  err_name_missing: {
    message: 'Attempting to create an interview without a name',
  },
  err_name_too_long: {
    message:
      'Attempting to create an interview with a name that exceeds the character limit',
  },
  err_kind_missing: {
    message: 'Attempting to create an interview without specifying the kind',
  },
  err_missing_location: {
    message: 'Attempting to create an interview without specifying a location',
  },
  err_source_missing: {
    message: 'Attempting to create an interview without specifying the source',
  },
  err_ats_job_stage_missing: {
    message:
      'Attempting to create an interview without specifying the ATS job stage',
  },
  err_ats_application_missing: {
    message:
      'Attempting to create an interview without specifying the ATS application',
  },
  err_ats_office_missing: {
    message:
      'Attempting to create an interview without specifying the ATS office',
  },
  err_onsite_location_missing: {
    message:
      'Attempting to create an interview without specifying an onsite location',
  },
  err_interview_pool_missing: {
    message:
      'Attempting to create an interview without specifying an interview pool',
  },
  err_note_taker_mandatory: {
    message: 'Attempting to create an interview without a mandatory note taker',
  },
  err_end_time_more_than_current_time: {
    message:
      'Attempting to create an interview where the end time is in the past',
  },
  err_end_time_less_than_start_time: {
    message:
      'Attempting to create an interview where the end time is earlier than the start time',
  },
  err_start_time_less_than_current_time: {
    message:
      'Attempting to create an interview where the start time is in the past',
  },
  err_end_time_less_than_or_eq_to_start_time: {
    message:
      'Attempting to create an interview where the end time is equal to or earlier than the start time',
  },
  err_duplicate_meeting_room_email_for_interview: {
    message:
      'Attempting to create an interview with a duplicate meeting room email',
  },
  err_duplicate_interview_ats_job_stage_action: {
    message:
      'Attempting to create an duplicate interview for a ATS job stage action',
  },
  err_ats_interview_not_found: {
    message: 'Attempting to update an interview that does not exist in ATS',
  },
  err_slot_taken_already: {
    message:
      'Attempting to create an interview where the slot is already taken',
  },
  err_contact_email_missing: {
    message: 'Attempting to create an interview without a contact email',
  },
  err_ats_schedule_not_found: {
    message: 'Attempting to send a candidate email without a from schedule',
  },
  err_contact_duplicate_interview_for_same_time: {
    message:
      'An interview has already been scheduled for this contact at the selected time. Please choose a different time.',
  },
  err_slots_overlapping: {
    message:
      'Attempting to create an interview where the slot is already taken. Please choose a different time.',
  },
  err_slots_missing: {
    message: 'Please add at least one available time slot.',
  },
  err_sender_mailbox_not_connected: {
    message: 'Email not connected',
  },
  err_candidate_email_sender_mailbox_not_connected: {
    message: 'Email not connected',
  },
  err_interviewer_email_sender_mailbox_not_connected: {
    message: 'Email not connected',
  },
  err_email_delegation_disabled: {
    message: 'Email delegation disabled',
  },
  err_slot_in_notice_time: {
    message:
      'At least one selected time slot falls within the minimum notice period. Try again with different slots.',
  },
  hackerrank_interview_update_error: {
    message: 'Failed to update interview. Try again later.',
  },
  hackerrank_interview_invite_failed: {
    message: 'Failed to schedule interview. Try again later.',
  },
  unable_to_update_hackerrank_interview: {
    message: 'Failed to update interview as it was deleted on HackerRank.',
  },
  hackerrank_interview_cancel_failed: {
    message: 'Failed to cancel interview. Try again later.',
  },
  hackerrank_interview_delete_failed: {
    message: 'Failed to delete interview. Try again later.',
  },
  unable_to_delete_hackerrank_interview: {
    message: 'Failed to cancel interview as it was deleted on HackerRank.',
  },
};

export default scheduler;
